var _div;
import { useCallback } from "react";
import { createUrlWithSourceQueryParams } from "@crehana/analytics";
import Calendar from "@crehana/compass.icons.outline/Calendar";
import { useCatalogEmptyStateContext } from "../../context";
import { useCatalogEmptyStateTranslations } from "../../hooks";
import { Container } from "../../ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CreateStudyPlanPanel = function CreateStudyPlanPanel() {
  var _useCatalogEmptyState = useCatalogEmptyStateContext(),
    source = _useCatalogEmptyState.source;
  var _useCatalogEmptyState2 = useCatalogEmptyStateTranslations(),
    t = _useCatalogEmptyState2.t;
  var handleClickCreateStudyPlan = useCallback(function () {
    window.location.href = createUrlWithSourceQueryParams({
      url: '/plan-de-estudios/',
      source: source,
      sourceDetail: 'Catalog Empty State Create Study Plan Button'
    });
  }, [source]);
  return /*#__PURE__*/_jsxs(Container, {
    className: "tw-flex tw-justify-between tw-items-center tw-mb-3.2",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-items-center",
      children: [_div || (_div = /*#__PURE__*/_jsx("div", {
        className: "tw-flex tw-items-center tw-justify-center tw-mr-2 tw-w-4 tw-h-4 tw-rounded-full tw-bg-primary-light-100",
        "aria-hidden": true,
        children: /*#__PURE__*/_jsx(Calendar, {
          size: 26,
          className: "tw-fill-current tw-text-primary-light-500"
        })
      })), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("h1", {
          className: "tw-font-subtitle4",
          children: t('CATALOG_EMPTY_STATE_STUDY_PLAN_TITLE')
        }), /*#__PURE__*/_jsx("p", {
          className: "tw-font-body4",
          children: t('CATALOG_EMPTY_STATE_STUDY_PLAN_DESCRIPTION')
        })]
      })]
    }), /*#__PURE__*/_jsx("button", {
      type: "button",
      className: "tw-btn-inverse-xs",
      onClick: handleClickCreateStudyPlan,
      children: t('CATALOG_EMPTY_STATE_STUDY_PLAN_BUTTON')
    })]
  });
};
export default CreateStudyPlanPanel;